import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardText, CardTitle, Col, FormGroup, Input, Label, Row, Table } from "reactstrap"

import { useWallet } from "../libs/useMetaMaskWallet"
import Web3 from "web3"
import votingJSON from "../../src/abi/MultipleVoting.json"

const votingAbi = votingJSON.abi
const pollId = 1
const ropstenVoteContract = '0x3194232434d4058f83603b5006ab400d3cd10bb8'


const Voting = () => {
    const web3 = new Web3(window.ethereum || window.web3)
    const [vote, setVote] = useState()
    const [pollDescription, setPollDescription] = useState()
    const [votingContract, setVotingContract] = useState()
   
    const wallet = useWallet()
    const address = wallet.account
    
    
    

    const onVoteValueChange = (e, type) => {
        const value = (e.target.value)
        switch (type) {
            case "auction":
                setVote(1)
                break
            case "lbp":
                setVote(2)
                break
            case "lwp":
                setVote(3)
                break
            case "ieo":
                setVote(4)
                break
            case "lwop":
                setVote(5)
                break
            default:
                return
        }
    }

    const voteFunction = async() => {
        let voteContract = new web3.eth.Contract(votingAbi, ropstenVoteContract)
        console.log('vote is: ' + vote)
        let castVote = await voteContract.methods.castVote(pollId, vote).send({
            from: address,
            gas: 320000,
            gasPrice: "45000000000"
        })

    }

 

 

    useEffect(() => {
        
            if (address) {

               let votingContract = new web3.eth.Contract(votingAbi, process.env.REACT_APP_ROPSTEN_VOTING_CONTRACT)
               setVotingContract(votingContract)
               
               } 
        }, [address])

    return (
        <React.Fragment>
            <div className="content">
                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle className="h3">Poll Details</CardTitle>
                                <Row>
                                    
                                    <Col lg={4}>
                                        <CardText className="P font-size-12 text-uppercase mb-1">Description: Idexo token launch options vote</CardText>
                                    </Col>
                                  
                                </Row>
                                <Row>
                               
                                </Row>
                                
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle className="h3">Choose an option</CardTitle>
                                
                                <Row>
                                <Col md={12}>
                                        <FormGroup className="mb-2">
                                            <Row>
                                                <Col>
                                                <Label>
                                                    <Input type="radio" checked={vote===1} onChange={(e) => onVoteValueChange(e, "auction")} />
                                                     Auction
                                                </Label>
                                                </Col>
                                                
                                            </Row>
                                            <Row>
                                                <Col>
                                                <Label>
                                                    <Input type="radio" checked={vote===2} onChange={(e) => onVoteValueChange(e, "lbp")} />
                                                     Liquidity Bootstrapping Pool
                                                </Label>
                                                </Col>
                                                
                                            </Row>
                                            <Row>
                                                <Col>
                                                <Label>
                                                    <Input type="radio" checked={vote===3} onChange={(e) => onVoteValueChange(e, "lwp")} />
                                                     Launchpad with Partner
                                                </Label>
                                                </Col>
                                                
                                            </Row>
                                            <Row>
                                                <Col>
                                                <Label>
                                                    <Input type="radio" checked={vote===4} onChange={(e) => onVoteValueChange(e, "ieo")} />
                                                     IEO
                                                </Label>
                                                </Col>
                                                
                                            </Row>
                                            <Row>
                                                <Col>
                                                <Label>
                                                    <Input type="radio" checked={vote===5} onChange={(e) => onVoteValueChange(e, "lwop")} />
                                                     Launchpad without Partner
                                                </Label>
                                                </Col>
                                                
                                            </Row>
                                           
                                            <Row>
                                                    <Button
                                                        color="primary"
                                                        className="waves-effect w-lg"
                                                        onClick={() => voteFunction(vote)}
                                                        style={{ width: "100%" }}
                                                    >
                                                        Vote
                                                    </Button>
                                            </Row>
                                        </FormGroup>
                                        
                                    </Col>
                                   
                                        
                                        
                                      
                                        
                                   
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
                
            </div>
        </React.Fragment>
    )
}

export default Voting
